<template>
  <div class="legislation-category">
    <navigator :items="items"></navigator>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="container-fluid">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-12">
                    <div class="title-section">Dados da categoria</div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-10 col-12">
                    <div class="form-group">
                      <label for>
                        Descrição
                        <span class="required-field">*</span>
                      </label>
                      <input type="text" v-model="category.name" class="form-control" />
                    </div>
                  </div>
                  <div class="col-lg-2 col-12">
                    <div class="form-group">
                      <label for>
                        Ordem
                        <span class="required-field">*</span>
                      </label>
                      <input type="number" min="0" v-model="category.order" class="form-control" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <button class="btn btn-primary float-right" v-on:click="save()">Salvar</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/api/axios";
import legislation_category_validate from "@/imports/validator/models/legislation_category";
import validator from "@/imports/validator/validate";
import Swal from "sweetalert2";
import { bus } from "@/main";

export default {
  name: "legislation-category",
  props: {
    id: Number
  },
  data() {
    return {
      formType: "create",
      category: {},
      items: [
        {
          text: "Categorias de legislação",
          route: "admin.legislation-categories"
        },
        {
          text: "Nova Categoria",
          active: true
        }
      ]
    };
  },
  mounted() {
    if (this.id) {
      this.formType = "edit";
      this.getDataObject(this.id);
    }
  },
  methods: {
    getDataObject: function(id) {
      bus.$emit("changeLoading", true);
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/legislation_categories/${id}`)
        .then(response => {
          this.category = response.data;
          this.items[1].text = this.category.name;
          bus.$emit("changeLoading", false);
        });
    },
    save: function() {
      let errors = validator.validate(
        this.category,
        legislation_category_validate.model
      );

      if (errors.length == 0) {
        bus.$emit("changeLoading", true);

        let promise =
          this.formType == "create"
            ? axios.post(
                `${process.env.VUE_APP_API_HOST}/api/legislation_categories`,
                this.category
              )
            : axios.put(
                `${process.env.VUE_APP_API_HOST}/api/legislation_categories/${this.category.id}`,
                this.category
              );

        promise
          .then(response => {
            bus.$emit("changeLoading", false);
            Swal.fire({
              title:
                this.formType == "create"
                  ? "Nova categoria cadastrada"
                  : "Categoria alterada com sucesso",
              icon: "success",
              onClose: () => {
                this.$router.push({ name: "admin.legislation-categories" });
              }
            });
          })
          .catch(error => {
            bus.$emit("changeLoading", false);
            Swal.fire({
              title: "Ocorreu um erro.",
              icon: "error"
            });
          });
      } else {
        let html = "Preencha todos os campos obrigatórios.";
        if (errors.length < 4) {
          html = "";
          errors.forEach(el => (html += el.message + "<br>"));
        }
        Swal.fire({
          title: "Atenção",
          html: html,
          icon: "warning"
        });
      }
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/General.scss";
</style>